<template>
  <div class="bg">
    <div class="container">
      <div class="header">
        <span>您正在报名参加{{ orderInfo.body }}</span>
      </div>
      <div class="content">
        <div class="car-title">
          <span>核对订单信息</span>
        </div>
        <div class="table">
          <el-table border :data="tableData">
            <el-table-column
              prop="body"
              align="center"
              label="商品信息"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="orderNo"
              align="center"
              label="订单号"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="totalAmount"
              align="center"
              label="订单金额"
              width="180"
            >
            </el-table-column>
            <el-table-column prop="createTime" align="center" label="下单日期">
            </el-table-column>
            <el-table-column prop="totalAmount" align="center" label="网银支付">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!-- <div class="content2">
        <div class="first">
          <span style="color: #333333; font-size: 18px; font-weight: bold"
            >是否开发票</span
          >
        </div>
        <div class="form">
          <el-radio v-model="radio" label="1">是</el-radio>
          <el-radio v-model="radio" label="2">否</el-radio>
          <div class="form-content" v-if="radio === '1'">
            <div style="background: #ffecd3; padding: 10px">
              <span style="color: #7e7e7e; font-size: 14px; font-weight: 400"
                >电子发票与纸质发票具有同等法律效力，可支持报销入账；同时根据增值税管理办法要求，如需为企业开具增值税发票，需提供纳税人识别号或统一社会信用代码，否则该发票无法作为税收凭证。</span
              >
            </div>
            <el-form
              :model="invoiceForm"
              :rules="rules"
              ref="invoiceForm"
              class="invoiceForm"
              label-width="100px"
            >
              <el-form-item label="发票抬头" prop="invoicesHead">
                <el-input v-model="invoiceForm.invoicesHead"></el-input>
              </el-form-item>
              <el-form-item label="企业税号" prop="invoicesCode">
                <el-input v-model="invoiceForm.invoicesCode"></el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="invoiceForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="invoiceForm.email"></el-input>
              </el-form-item>
              <el-form-item label="发票金额">
                <el-input
                  disabled
                  v-model="invoiceForm.invoicesPrice"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div> -->
      <!-- <div class="content3">
        <div class="first">
          <span style="color: #333333; font-size: 18px; font-weight: bold"
            >付款方式</span
          >
        </div>
        <div class="pt">
          <span style="color: #333333; font-size: 14px; display: block"
            >支付平台</span
          >
          <div style="margin-top: 20px">
            <el-radio v-model="radio2" label="1" border size="medium"
              >支付宝</el-radio
            >
            <el-radio v-model="radio2" label="2" border size="medium"
              >微信
            </el-radio>
          </div>
          <div class="fangs">
            <img
              src="../../assets/image/alipay.png"
              v-if="radio2 == 1"
              alt=""
            />
            <svg
              v-else
              width="264px"
              height="34px"
              viewBox="0 0 264 34"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <title>logo</title>
              <desc>Created with Sketch.</desc>
              <g
                id="组件"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="导航/头部菜单_内容"
                  transform="translate(0.000000, -70.000000)"
                >
                  <g id="logo" transform="translate(0.000000, 70.000000)">
                    <g id="微信支付logo">
                      <path
                        d="M13.9879326,21.4155844 C13.8125353,21.5038961 13.637138,21.5480519 13.4178914,21.5480519 C12.9355489,21.5480519 12.5409051,21.2831169 12.3216585,20.8857143 L12.2339598,20.7090909 L8.76986368,13.1142857 C8.72601436,13.025974 8.72601436,12.9376623 8.72601436,12.8493506 C8.72601436,12.4961039 8.98911027,12.2311688 9.33990482,12.2311688 C9.47145277,12.2311688 9.60300073,12.2753247 9.73454868,12.3636364 L13.8125353,15.2779221 C14.1194805,15.4545455 14.4702751,15.587013 14.8649189,15.587013 C15.0841655,15.587013 15.3034121,15.5428571 15.5226587,15.4545455 L34.6409615,6.88831169 C31.2207147,2.82597403 25.5641526,0.176623377 19.1621521,0.176623377 C8.72601436,0.176623377 0.219246592,7.28571429 0.219246592,16.0727273 C0.219246592,20.8415584 2.76250706,25.1688312 6.75279503,28.0831169 C7.05974026,28.3038961 7.27898685,28.7012987 7.27898685,29.0987013 C7.27898685,29.2311688 7.23513753,29.3636364 7.19128821,29.4961039 C6.88434299,30.6883117 6.35815117,32.6311688 6.35815117,32.7194805 C6.31430185,32.8519481 6.27045253,33.0285714 6.27045253,33.2051948 C6.27045253,33.5584416 6.53354844,33.8233766 6.88434299,33.8233766 C7.01589094,33.8233766 7.1474389,33.7792208 7.23513753,33.6909091 L11.3569735,31.2623377 C11.6639187,31.0857143 12.0147132,30.9532468 12.3655078,30.9532468 C12.5409051,30.9532468 12.7601516,30.9974026 12.9355489,31.0415584 C14.8649189,31.6155844 16.9696862,31.9246753 19.1183028,31.9246753 C29.5544406,31.9246753 38.0612084,24.8155844 38.0612084,16.0285714 C38.0612084,13.3792208 37.2719206,10.8623377 35.9125918,8.65454545 L14.1194805,21.3272727 L13.9879326,21.4155844 Z"
                        id="XMLID_81_"
                        fill="#22AC38"
                      />
                      <rect
                        id="XMLID_80_"
                        fill="#494949"
                        x="83.6206502"
                        y="11.4363636"
                        width="14.2071792"
                        height="1.28051948"
                      />
                      <rect
                        id="XMLID_79_"
                        fill="#494949"
                        x="83.6206502"
                        y="15.4103896"
                        width="14.2071792"
                        height="1.36883117"
                      />
                      <path
                        d="M97.4331854,27.2883117 L97.4331854,19.5168831 L83.9714447,19.5168831 L83.9714447,27.2441558 L97.4331854,27.2441558 L97.4331854,27.2883117 Z M85.3307736,20.7974026 L96.0738566,20.7974026 L96.0738566,25.9636364 L85.3307736,25.9636364 L85.3307736,20.7974026 Z"
                        id="XMLID_76_"
                        fill="#494949"
                        fill-rule="nonzero"
                      />
                      <path
                        d="M79.7180608,28.0831169 L79.7180608,10.2883117 C80.5073486,8.52207792 81.252787,6.66753247 81.8228281,4.76883117 L80.5511979,4.01818182 C79.2795676,8.47792208 77.4817456,12.4961039 75.1577317,15.8961039 L75.9031701,17.2207792 C76.6924579,16.0285714 77.5255949,14.6155844 78.358732,13.1584416 L78.358732,28.1272727 L79.7180608,28.1272727 L79.7180608,28.0831169 Z"
                        id="XMLID_75_"
                        fill="#494949"
                      />
                      <path
                        d="M131.284859,28.0831169 L131.284859,10.2883117 C132.074147,8.52207792 132.819585,6.66753247 133.389627,4.76883117 L132.117996,4.01818182 C130.846366,8.47792208 129.048544,12.4961039 126.72453,15.8961039 L127.469969,17.2207792 C128.259256,16.0285714 129.092393,14.6155844 129.92553,13.1584416 L129.92553,28.1272727 L131.284859,28.1272727 L131.284859,28.0831169 Z"
                        id="XMLID_74_"
                        fill="#494949"
                      />
                      <path
                        d="M99.3187061,7.32987013 L90.9873356,7.32987013 L91.864322,6.8 L91.9081713,6.8 L91.9081713,6.75584416 C91.8204727,6.53506494 91.5573768,5.96103896 91.2504316,5.34285714 C90.9873356,4.76883117 90.7242397,4.23896104 90.5926918,3.92987013 L90.5926918,3.88571429 L89.3210615,4.63636364 L89.3210615,4.68051948 C89.7595547,5.51948052 90.1541986,6.31428571 90.5049931,7.06493506 C90.5488425,7.15324675 90.5926918,7.24155844 90.5926918,7.28571429 L82.2613213,7.28571429 L82.2613213,8.65454545 L99.3187061,8.65454545 L99.3187061,7.32987013 Z"
                        id="XMLID_73_"
                        fill="#494949"
                      />
                      <polygon
                        id="XMLID_72_"
                        fill="#494949"
                        points="62.660676 6.27012987 61.3890457 6.27012987 61.3890457 10.774026 58.9773332 10.774026 58.9773332 4.37142857 57.705703 4.37142857 57.705703 10.774026 55.2062918 10.774026 55.2062918 6.27012987 53.9346616 6.27012987 53.9346616 12.0545455 62.660676 12.0545455"
                      />
                      <rect
                        id="XMLID_71_"
                        fill="#494949"
                        x="54.3293055"
                        y="14.5714286"
                        width="7.71748004"
                        height="1.28051948"
                      />
                      <path
                        d="M55.9955796,20.8415584 L55.9955796,19.6935065 L59.8981689,19.6935065 L59.8981689,22.5194805 C59.8543196,23.5350649 59.8104703,23.8441558 59.4596757,24.2857143 L60.2489635,25.6545455 L60.2928128,25.6103896 C60.9944019,25.0363636 62.1344841,24.0649351 63.7569089,22.6077922 L63.8007582,22.6077922 L63.1868678,21.5480519 L63.1430185,21.5038961 L61.1697991,23.1818182 L61.1697991,18.3688312 L54.6362507,18.3688312 L54.6362507,20.3116883 C54.811648,22.961039 54.1539082,24.8597403 52.6630314,25.9636364 L52.6191821,25.9636364 L53.3207712,27.2 L53.3646205,27.2441558 L53.4084698,27.2 C55.2501412,25.7428571 56.1271275,23.5792208 55.9955796,20.8415584 Z"
                        id="XMLID_70_"
                        fill="#494949"
                      />
                      <path
                        d="M47.6642091,10.4207792 L48.4534968,11.7454545 C50.4267161,9.75844156 52.1368396,7.37402597 53.3646205,4.76883117 L52.1806889,4.06233766 C50.9090586,6.62337662 49.3743325,8.78701299 47.6642091,10.4207792 Z"
                        id="XMLID_69_"
                        fill="#494949"
                      />
                      <path
                        d="M47.3134145,18.5012987 L48.0150036,19.7376623 L48.0588529,19.7818182 L48.1027023,19.7376623 C48.8481407,18.8545455 49.5935791,17.9272727 50.2951682,16.9558442 L50.2951682,28.0831169 L51.5667984,28.0831169 L51.5667984,14.8363636 C52.1368396,13.8207792 52.7068807,12.6727273 53.2330725,11.3922078 L53.2330725,11.3480519 L52.0052916,10.6415584 L52.0052916,10.6857143 C50.7775107,13.6441558 49.2427845,16.2935065 47.3134145,18.5012987 Z"
                        id="XMLID_68_"
                        fill="#494949"
                      />
                      <path
                        d="M72.0005808,10.0675325 L72.0005808,8.78701299 L66.3440187,8.78701299 C66.8263612,7.28571429 67.3964024,5.56363636 67.5717996,4.10649351 L66.2563201,4.10649351 C65.423183,7.99220779 64.1515528,11.3922078 62.529128,14.0415584 L63.3184157,15.4545455 L63.8884569,14.2623377 C64.1077035,13.8649351 64.2831008,13.5558442 64.4146487,13.2909091 C64.8092926,16.7350649 65.5108817,19.5168831 66.4755667,21.5480519 C65.554731,23.1818182 64.1077035,24.8597403 62.1783335,26.5818182 L62.1344841,26.5818182 L62.8799226,27.8623377 L62.9237719,27.9064935 L62.9676212,27.8623377 C64.9846898,25.9636364 66.387868,24.2857143 67.1333064,22.9168831 C67.9664435,24.4181818 69.413471,26.2285714 71.0358958,27.9506494 L71.0797451,27.9948052 L71.8251835,26.6701299 L71.8251835,26.625974 L71.7813342,26.625974 C70.0273615,24.9038961 68.6241833,23.1376623 67.8348955,21.6363636 C69.281923,18.987013 70.1589094,15.1012987 70.509704,10.0675325 L72.0005808,10.0675325 Z M67.3087037,20.0025974 C66.4755667,17.838961 65.8616762,14.8805195 65.4670323,11.2155844 C65.5985803,10.8181818 65.7739776,10.4207792 65.9493748,10.0675325 L69.3696217,10.0675325 C69.0626765,14.2181818 68.4049367,17.574026 67.3087037,20.0025974 Z"
                        id="XMLID_65_"
                        fill="#494949"
                        fill-rule="nonzero"
                      />
                      <path
                        d="M125.102105,8.6987013 L125.102105,7.32987013 L114.271324,7.32987013 L114.271324,3.84155844 L112.868146,3.84155844 L112.868146,7.32987013 L102.125063,7.32987013 L102.125063,8.6987013 L112.868146,8.6987013 L112.868146,13.2467532 L112.648899,13.2467532 L105.896104,13.2467532 L105.896104,14.4831169 C105.896104,14.4831169 106.948488,16.9116883 109.140953,19.561039 C110.01794,20.6207792 111.026474,21.7246753 112.341954,22.8285714 C109.886392,24.3298701 106.860789,25.787013 102.607405,26.625974 L103.396693,28.038961 C103.396693,28.038961 108.439364,26.9792208 113.438187,23.7116883 C114.095926,24.1532468 117.209228,26.625974 122.997338,28.038961 C122.997338,28.038961 122.997338,28.038961 122.997338,28.038961 L123.041187,28.038961 L123.611229,26.9792208 C123.611229,26.9792208 122.120352,26.5818182 119.840187,25.6987013 C118.261612,25.0805195 116.288392,24.1532468 114.402872,22.8727273 C117.209228,20.7974026 119.708639,17.7948052 121.199516,13.9532468 L120.059434,13.2909091 L114.227474,13.2909091 L114.227474,8.6987013 L125.102105,8.6987013 Z M119.620941,14.438961 C119.620941,14.438961 118.217762,18.4571429 113.438187,21.9012987 C111.158022,20.1350649 108.790159,17.574026 107.299282,14.438961 L119.620941,14.438961 Z"
                        id="XMLID_35_"
                        fill="#494949"
                        fill-rule="nonzero"
                      />
                      <path
                        d="M142.554134,26.3168831 C142.291038,26.3168831 142.027942,26.3168831 141.764846,26.3168831 L141.764846,27.6857143 C142.291038,27.6857143 142.685682,27.6857143 142.948778,27.6857143 C144.308107,27.6857143 145.009696,27.3766234 145.623586,26.8025974 C146.193627,26.2285714 146.456723,25.3896104 146.412874,24.2415584 L146.412874,11.3922078 L150.096217,11.3922078 L150.096217,10.0233766 L146.412874,10.0233766 L146.412874,4.10649351 L145.053545,4.10649351 L145.053545,10.0233766 L133.740421,10.0233766 L133.740421,11.3922078 L145.053545,11.3922078 L145.053545,24.2415584 C145.009696,25.6545455 144.13271,26.3168831 142.554134,26.3168831 Z"
                        id="XMLID_34_"
                        fill="#494949"
                      />
                      <path
                        d="M139.484682,21.7246753 L140.844011,20.9298701 C140.098572,19.4285714 139.133887,17.4415584 137.949956,15.012987 L136.722175,15.7636364 C137.511462,17.3974026 138.432298,19.3844156 139.484682,21.7246753 Z"
                        id="XMLID_33_"
                        fill="#494949"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div> -->
      <div class="footer">
        <div
          style="
            display: flex;
            justify-content: flex-end;
            box-sizing: border-box;
          "
        >
          <div style="display: flex; align-items: center; margin-top: 10px">
            <div style="margin-right: 20px; text-align: center">
              <span class="yinfu"
                >应付总金额：<span class="price"
                  >¥{{ orderInfo.totalAmount }}</span
                ></span
              >
              <!-- <p class="desc">(支付成功后，会短信通知您）</p> -->
            </div>
            <el-button class="qued" @click="pay">立即支付</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cookie from "@/api/cookie";
import api from "../../api";

export default {
  name: "index",
  data() {
    return {
      orderInfo: {},
      tableData: [],
      radio: "1",
      radio2: "1", //支付方式 1支付宝 2微信
      // isPay:false,
      invoiceForm: {
        invoicesHead: "",
        invoicesCode: "",
        phone: "",
        email: "",
        invoicesPrice: "",
      },
      rules: {
        invoicesHead: [
          { required: true, message: "请输入发票抬头", trigger: "blur" },
        ],
        invoicesCode: [
          { required: true, message: "请输入企业税号", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
      canBack: false,
    };
  },
  methods: {
    insertInvoices() {
      let remarks = {
        phone: this.invoiceForm.phone,
        email: this.invoiceForm.email,
      };
      let data = {
        classId: this.orderInfo.classId,
        invoicesHead: this.invoiceForm.invoicesHead,
        invoicesCode: this.invoiceForm.invoicesCode,
        invoicesPrice: this.orderInfo.totalAmount,
        ordersIdList: [this.orderInfo.ordersId],
        remarks: JSON.stringify(remarks),
        ordersId: this.orderInfo.ordersId,
        userId: cookie.getCookie("userId"),
      };
      console.log(data);
      api.invoices(data).then((res) => {
        console.log(res);
      });
    },
    pay() {
      // if (this.radio == '1') {
      //   // let reg =
      //   //   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ //邮箱
      //   // let reg2 =
      //   //   /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/ //手机

      //   // if (
      //   //   this.invoiceForm.invoicesHead == '' ||
      //   //   this.invoiceForm.invoicesCode == '' ||
      //   //   this.invoiceForm.phone == '' ||
      //   //   this.invoiceForm.email == ''
      //   // ) {
      //   //   this.$message({
      //   //     type: 'error',
      //   //     message: '请完善发票信息',
      //   //   })
      //   // } else
      //   if (reg.test(this.invoiceForm.email) === false) {
      //     this.$message({
      //       type: 'error',
      //       message: '邮箱格式不正确',
      //     })
      //   } else if (reg2.test(this.invoiceForm.phone) === false) {
      //     this.$message({
      //       type: 'error',
      //       message: '手机号码格式不正确',
      //     })
      //   } else {
      //     // this.insertInvoices()
      //     let data = {
      //       body: this.orderInfo.body,
      //       out_trade_no: this.orderInfo.orderNo,
      //       subject: this.orderInfo.subject,
      //       total_amount: this.orderInfo.totalAmount,
      //     }
      //     api.pay(data).then((res) => {
      //       document.querySelector('body').innerHTML = res.data.aliPay //查找到当前页面的body，将后台返回的form替换掉他的内容
      //       document.forms[0].submit() //执行submit表单提交，让页面重定向，跳转到支付宝页面
      //     })
      //   }
      // } else {
      //   let data = {
      //     body: this.orderInfo.body,
      //     out_trade_no: this.orderInfo.orderNo,
      //     subject: this.orderInfo.subject,
      //     total_amount: this.orderInfo.totalAmount,
      //   }
      //   api.pay(data).then((res) => {
      //     document.querySelector('body').innerHTML = res.data.aliPay //查找到当前页面的body，将后台返回的form替换掉他的内容
      //     document.forms[0].submit() //执行submit表单提交，让页面重定向，跳转到支付宝页面
      //   })
      // }
      if (this.$route.query.type == "0") {
        let data = {
          body: this.orderInfo.body,
          out_trade_no: this.orderInfo.orderNo,
          subject: this.orderInfo.subject,
          total_amount: this.orderInfo.totalAmount,
        };
        api.pay(data).then((res) => {
          document.querySelector("body").innerHTML = res.data.aliPay; //查找到当前页面的body，将后台返回的form替换掉他的内容
          document.forms[0].submit(); //执行submit表单提交，让页面重定向，跳转到支付宝页面
        });
      } else {
        this.$router.push({
          path: "/weixin",
          query: {
            out_trade_no: this.orderInfo.ordersId,
            total_amount: this.orderInfo.totalAmount,
            createTime: this.orderInfo.orderNo,
          },
        });
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "年";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "月";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日";
      return Y + M + D;
    },
    popState() {
      // if (!this.canBack) {
      history.pushState(null, null, null);
      this.$confirm(
        "返回上一页面将重新创建订单，该笔订单仍可在10分钟内于个人中心-我的订单中进行继续支付",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$router.go(-2);
        })
        .catch(() => {});
    },
  },
  created() {
    this.invoiceForm.invoicesPrice = this.$route.query.totalAmount;
    this.orderInfo = this.$route.query;
    this.tableData.push(this.$route.query);
    this.tableData.forEach((item) => {
      item.createTime = this.timestampToTime(parseInt(item.createTime));
    });
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.popState, false);
  },
  destroyed() {
    window.removeEventListener("popstate", this.popState, false);
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  min-height: 600px;
  margin: 20px auto;
  background: #ffffff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .header {
    display: flex;
    margin-top: 10px;
    margin-bottom: 20px;
    align-items: center;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
  }

  .content {
    .first {
      border-bottom: 2px solid #dc2325;
      width: 112px;
    }

    .table {
      margin-top: 20px;
    }
  }

  .content2 {
    margin-top: 20px;
    padding: 10px;

    .first {
      width: 96px;
    }

    .form {
      border: 1px solid #f0f0f0;
      margin-top: 20px;
      padding: 10px 20px;

      .form-content {
        margin-top: 20px;

        .invoiceForm {
          width: 400px;
          margin: 20px auto;
        }
      }
    }
  }

  .content3 {
    margin-top: 20px;
    padding: 10px;

    .first {
      width: 75px;
    }

    .pt {
      border: 1px solid #f0f0f0;
      margin-top: 20px;
      padding: 20px;

      // img {
      //   margin-top: 20px;
      //   margin-left: 20px;
      // }

      .fangs {
        margin: 20px 0px 0px 20px;
      }
    }
  }
}

.footer {
  margin-top: auto;
  .desc {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    margin: 0px;
  }
  .yinfu {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    .price {
      font-weight: bold;
      font-size: 24px;
      color: #264f99;
      line-height: 33px;
      text-align: left;
      font-style: normal;
    }
  }

  .qued {
    background: #264f99;
    border-radius: 4px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    height: 50px;
    color: #ffffff;
  }
}

::v-deep .has-gutter {
  .el-table__cell {
    background: #f6f7fb;
  }
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border: none;
}

.card {
  width: 1200px;
  background: #ffffff;
  padding: 24px 20px;
  box-sizing: border-box;
}

.car-title {
  position: relative;
  text-align: left;
  padding-left: 8px;
  height: 22px;
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #264f99;
  line-height: 22px;
  text-align: justify;
  font-style: normal;
}
.car-title::before {
  content: "";
  width: 4px;
  height: 12px;
  background: #264f99;
  display: block;
  position: absolute;
  top: 6px;
  left: 0px;
}
</style>
